function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from "react";
import NucleusButton from "../../legacy/Button/Button";
import AdjustIcon from "../../Icon/Adjust";
import XIcon from "../../Icon/X";
import { buildTestIdProp } from "@cvent/nucleus-test-automation";
import useStyle from "./Search.style";
export var ClearSearchTextButton = function(param) {
    var testID = param.testID, isRtl = param.isRtl, breakpoints = param.breakpoints, isSearchOpen = param.isSearchOpen, accessibilityLabel = param.accessibilityLabel, clearSearchTerm = param.clearSearchTerm, forwardedRef = param.forwardedRef, closeSearch = param.closeSearch;
    var ref1 = useStyle({
        isRtl: isRtl,
        breakpoints: breakpoints,
        isSearchOpen: isSearchOpen
    }), iconWrapperStyles = ref1.iconWrapperStyles, searchButtonStyles = ref1.searchButtonStyles, searchIconStyles = ref1.searchIconStyles;
    return _jsx("div", {
        css: iconWrapperStyles,
        children: _jsx(NucleusButton, _objectSpread({}, buildTestIdProp([
            testID,
            'clear'
        ]), {
            iconBefore: function() {
                return _jsx(XIcon, {
                    size: "s"
                });
            },
            iconStyle: searchIconStyles,
            style: searchButtonStyles,
            onClick: function(e) {
                var ref;
                e.stopPropagation();
                if (clearSearchTerm) {
                    clearSearchTerm();
                }
                return forwardedRef === null || forwardedRef === void 0 ? void 0 : (ref = forwardedRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            },
            accessibilityLabel: accessibilityLabel,
            onBlur: closeSearch,
            "aria-haspopup": true
        }))
    });
};
export var MoreFiltersButton = function(param) {
    var _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, breakpoints = param.breakpoints, isSearchOpen = param.isSearchOpen, testID = param.testID, accessibilityLabel = param.accessibilityLabel, closeSearch = param.closeSearch, openFilters = param.openFilters, isFiltersOpen = param.isFiltersOpen;
    var ref = useStyle({
        isRtl: isRtl,
        breakpoints: breakpoints,
        isSearchOpen: isSearchOpen
    }), iconWrapperStyles = ref.iconWrapperStyles, searchButtonStyles = ref.searchButtonStyles, searchIconStyles = ref.searchIconStyles;
    return _jsx("div", {
        css: iconWrapperStyles,
        children: _jsx(NucleusButton, _objectSpread({}, buildTestIdProp([
            testID,
            'toggle-flyout'
        ]), {
            iconBefore: function() {
                return _jsx(AdjustIcon, {
                    size: "s"
                });
            },
            iconStyle: searchIconStyles,
            style: searchButtonStyles,
            onClick: openFilters,
            onBlur: closeSearch,
            accessibilityLabel: accessibilityLabel,
            "aria-haspopup": true,
            "aria-expanded": isFiltersOpen
        }))
    });
};
